import { useParams, Navigate } from "react-router-dom";
import CareerPage from "../../pages/careers/CareerPage";

const CareerPageGuard = ({ careers }) => {
  const { url } = useParams();
  const career = careers.find((c) => c.url === url);

  if (!career) {
    return <Navigate replace to="/404" />;
  }

  return <CareerPage career={career} />;
};

export default CareerPageGuard;